import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/opt/hotlistcasino/frontend/src/app/[lang]/forgot-password/ui.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthPageShell"] */ "/opt/hotlistcasino/frontend/src/components/AuthPageShell.tsx");
